import { useState } from "react";
import { Lock, Crown } from "lucide-react";
import { AuthDialog, PayDialog } from "@/components/UnlockGuess";
import { requestPremium } from "@/services/api";

const PLAN_LABEL = { 1: "1 Din", 7: "7 Din", 30: "30 Din" };

export function PremiumLock({ d, onDone }) {
  const plans = d.plans || {};
  const [auth, setAuth] = useState(false);
  const [plan, setPlan] = useState(null);
  const avail = Object.entries(plans || {}).filter(([, p]) => p > 0);
  return (
    <div data-testid="premium-lock" className="flex flex-col items-center gap-3 rounded-2xl border-2 border-dashed border-[color:var(--border-gold)] p-6 text-center">
      <Lock className="h-8 w-8 text-[color:var(--accent-crimson)]" />
      <p className="font-display text-lg font-extrabold">{d.name} · Premium Guessing</p>
      {d.login_required ? (
        <button type="button" data-testid="premium-login" onClick={() => setAuth(true)} className="btn-gold rounded-full px-5 py-2 text-sm font-bold">Login / Register</button>
      ) : avail.length ? (
        <div className="flex flex-wrap justify-center gap-2">
          {avail.map(([k, p]) => (
            <button key={k} type="button" data-testid={`premium-plan-${k}`} onClick={() => setPlan(k)}
              className="flex flex-col items-center rounded-xl border-2 border-[color:var(--border-gold)] bg-[color:var(--bg-card)] px-4 py-2 transition-transform hover:-translate-y-0.5">
              <Crown className="h-4 w-4 text-amber-500" />
              <span className="text-sm font-extrabold">{d.name} · {PLAN_LABEL[k]}</span>
              <span className="font-mono text-base font-black text-emerald-600">₹{p}</span>
            </button>
          ))}
        </div>
      ) : <p className="text-xs text-red-600">Premium plan is not available right now.</p>}
      <AuthDialog open={auth} onOpenChange={setAuth} onDone={() => { setAuth(false); onDone(); }} />
      {plan && (
        <PayDialog open={!!plan} onOpenChange={(o) => !o && setPlan(null)} title={`${d.name} ${PLAN_LABEL[plan]} Premium plan`}
          desc={`Ank Mix, Combo Jodi/Panel/Sangam, Best Jodi · ₹${plans[plan]}`} price={plans[plan]} note={`PREMIUM ${d.name}`}
          onRequest={() => requestPremium(plan, d.category_id)} onUnlocked={() => { setPlan(null); onDone(); }} />
      )}
    </div>
  );
}
